import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './wedding_v2/Header';
import Footer from './wedding_v2/Footer';
import Home from './wedding_v2/Home';
import Story from './wedding_v2/Story';
import Days from './wedding_v2/Days';
import Rsvp from './wedding_v2/Rsvp';

export default function WeddingTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F8E6DC]" data-testid="em-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`em-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'story' && <Story setPage={setPage} />}
          {page === 'days' && <Days setPage={setPage} />}
          {page === 'rsvp' && <Rsvp setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
